import styled from 'styled-components'

const StyledAnimationContainer = styled.div`
  position: relative;
  float: left;
  width: 100%;
  overflow-y: hidden;
`

export default StyledAnimationContainer
